import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getFeaturedGames, FeaturedGame } from '../../services/featuredGames';

const PREVIEW_START = 0.5;

export default function FeaturedGamesSection() {
  const { t } = useTranslation('landing');
  const [games, setGames] = useState<FeaturedGame[]>([]);

  useEffect(() => {
    getFeaturedGames()
      .then(setGames)
      .catch(() => setGames([]));
  }, []);

  if (games.length === 0) return null;

  const play = (video: HTMLVideoElement | null) => video?.play().catch(() => {});
  const rewind = (video: HTMLVideoElement | null) => {
    if (!video) return;
    video.pause();
    video.currentTime = PREVIEW_START;
  };

  return (
    <section id="games" className="section" style={{ paddingTop: 'var(--section-y-lg)', scrollMarginTop: 'var(--header-h)' }}>
      <h2 className="t-h2-sm" style={{ margin: '0 0 40px' }}>
        {t('games.titleA', 'Games built by the')}
        <br />
        <span className="t-accent">{t('games.titleB', 'community this week.')}</span>
      </h2>
      <div className="featured-games scroll-hide">
        {games.map((g) => (
          <a
            key={g.projectId}
            href={`/play/${g.projectId}`}
            className="game-tile"
            onMouseEnter={(e) => play(e.currentTarget.querySelector('video'))}
            onMouseLeave={(e) => rewind(e.currentTarget.querySelector('video'))}
            onFocus={(e) => play(e.currentTarget.querySelector('video'))}
            onBlur={(e) => rewind(e.currentTarget.querySelector('video'))}
          >
            <div className="frame">
              <div className="frame-inner" style={{ aspectRatio: '3 / 4' }}>
                <video
                  src={`${g.videoUrl}#t=${PREVIEW_START}`}
                  poster={g.thumbnailUrl ?? undefined}
                  preload="metadata"
                  muted
                  loop
                  playsInline
                />
              </div>
            </div>
            <span style={{ fontWeight: 600, fontSize: 16 }}>{g.name}</span>
          </a>
        ))}
      </div>
    </section>
  );
}
